import React from 'react';
import moment from 'moment';
import Datetime from 'react-datetime';
import { FormControl, InputLabel } from '@material-ui/core';
import NumberMaskInput from '../../../components/CustomInput/NumberMaskInput';
import CustomInput from '../../../components/CustomInput/CustomInput';

export default class AdvancedScheduleManager extends React.Component {

    state = {
        runtime: moment().startOf("day"),
        time_frequency: moment().startOf("day"),
        daily: null,
        weekly: null,
        monthly: null
    }

    componentDidMount() {
        if(this.props.report)
            this.setState({ ...this.props.report });
    }

    getSchedule = () => ({
            ...this.state,
            runtime: this.state.runtime.format("HH:mm"),
            time_frequency: this.state.time_frequency.format("HH:mm") === "00:00" ? null : this.state.time_frequency.format("HH:mm:ss")
        })

    render() {
        return (
            <div>
                <FormControl 
                    fullWidth
                    style={{ marginTop: 10 }}
                >
                    <InputLabel
                        htmlFor="run_at"
                        style={{
                            top: -8,
                            color: '#AAAAAA !important',
                            fontSize: 14,
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 400,
                            lineHeight: 1.42857
                        }}
                        shrink
                    >
                        Run at</InputLabel>
                    <Datetime
                        id="run_at"
                        dateFormat={false}
                        inputProps={{ placeholder: "Run at", id: 'run_at' }}
                        timeFormat={"HH:mm"}
                        timeConstraints={{ minutes: { step: 5 } }}
                        value={this.state.runtime}
                        onChange={(val) => this.setState({ runtime: val })}
                    />
                </FormControl>

                <FormControl 
                    fullWidth
                    style={{ marginTop: 36 }}
                >
                    <InputLabel
                        htmlFor="time_frequency"
                        style={{
                            top: -8,
                            color: '#AAAAAA !important',
                            fontSize: 14,
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 400,
                            lineHeight: 1.42857
                        }}
                        shrink
                    >Time Frequency</InputLabel>
                    <Datetime
                        id="time_frequency"
                        dateFormat={false}
                        inputProps={{ placeholder: "Time Frequency", id: 'time_frequency' }}
                        timeFormat={"HH:mm"}
                        timeConstraints={{ minutes: { step: 5 } }}
                        value={this.state.time_frequency}
                        onChange={(val) => this.setState({ time_frequency: val })}
                    />
                </FormControl>

                <NumberMaskInput
                    type="number"
                    labelText="Day Frequency"
                    id="daily"
                    formControlProps={{
                        fullWidth: true,
                        style: { marginTop: 14 }
                    }}
                    inputProps={{
                        onChange: event => this.setState({ daily: event.target.value }),
                        value: this.state.daily,
                    }}
                />

                <CustomInput
                    labelText={"Weekly"}
                    id="weekly"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        onChange: event => { },
                        value: this.state.weekly,
                    }}
                />

                <CustomInput
                    labelText={"Monthly"}
                    id="monthly"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        onChange: event => { },
                        value: this.state.monthly,
                    }}
                />
            </div>
        );
    }
}